import React, { FunctionComponent, ReactNode, MouseEvent } from "react";
import classnames from 'classnames';


export interface IDropdownAction {
  label: string | ReactNode;
  onClick: (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>, index?: number | string) => void;
  [key: string]: any;
}

export interface IDropdownActions {
  actions: IDropdownAction[];
  index?: number | string;
}

export const DropdownActions: FunctionComponent<IDropdownActions> = ({ actions }: IDropdownActions) => {
  return <>
    {actions && actions.map((action, idx) => {
      const { label, onClick, className, props: actionProps } = action;
      return <button
          {...actionProps}
          className={classnames('dropdown-item text-secondary small', className)}
          onClick={(e) => onClick ? onClick(e, idx) : () => {}}
        >
          {label}
        </button>
    })}
  </>;
}

DropdownActions.defaultProps = {
  actions: [],
};

export default DropdownActions;
